import {
  IBadgeDetail,
  IBadgeIssueResData,
  IBadgeTemplate,
  TBadgeStatisticsDuration,
  TBadgeTemplateFilter,
  TFetchBadgeIusseListSbtStatusType,
} from '@contexts/BadgeContext/types';
import { faker } from '@faker-js/faker';

class BadgeTemplate {
  currentPage = 1;
  initalData;
  data;
  totalElementCount;
  totalPage;
  limit;
  constructor({ size }: { size: number }) {
    this.initalData = Array.from(
      { length: size },
      this.createMockBadgeTemplate,
    );
    this.data = this.initalData;
    this.totalElementCount = size;
    this.totalPage = Math.ceil(size / this.limit);
  }

  createMockBadgeTemplate(): IBadgeTemplate {
    const badgeName = `BADGE No.${faker.number.int({ max: 10000 })}`;
    return {
      id: faker.string.uuid(),
      createdAt: faker.date.recent().toISOString(),
      name: badgeName,
      badgeImageUrl: faker.image.urlPlaceholder({
        height: 640,
        width: 640,
        text: badgeName,
      }),
      description: faker.commerce.productDescription(),
      relationLink: faker.internet.url(),
      isCertificationSbtTemplate: false,
      isTemplateActive: faker.datatype.boolean(),
      expiredAt: faker.date.future().toISOString(),
      customField: ['string'],
      creatorId: faker.string.uuid(),
      creatorName: faker.person.fullName(),
      isOwned: true,
      isSbtActive: true,
      issuedQuantity: faker.number.int({ min: 0, max: 10 }),
    };
  }

  get({ requestPageNumber }: { requestPageNumber: number }) {
    const startIndex = (requestPageNumber - 1) * this.limit;
    const endIndex = startIndex + this.limit;

    return {
      currentPage: requestPageNumber,
      data: this.data.slice(startIndex, endIndex),
      totalElementCount: this.totalElementCount,
      totalPage: this.totalPage,
    };
  }

  set({
    activeType,
    limit,
    search,
  }: {
    activeType: TBadgeTemplateFilter;
    limit: number;
    search?: string;
  }) {
    let result = this.initalData;
    if (search) {
      result = result.filter((item) => item.name === search);
    }

    if (activeType === 'ACTIVE') {
      this.data = result.filter((item) => item.isTemplateActive);
    } else if (activeType === 'INACTIVE') {
      this.data = result.filter((item) => !item.isTemplateActive);
    } else {
      this.data = result;
    }
    this.limit = limit;
    this.totalElementCount = this.data.length;
    this.totalPage = Math.ceil(this.totalElementCount / this.limit);
  }
}

export const badgeTemplates = new BadgeTemplate({ size: 38 });

class BadgeIusseData {
  currentPage = 1;
  initalData;
  data;
  totalElementCount;
  totalPage;
  limit;
  constructor({ size }: { size: number }) {
    this.initalData = Array.from({ length: size }, this.createBadgeIssueObject);
    this.data = this.initalData;
    this.totalElementCount = size;
    this.totalPage = Math.ceil(size / this.limit);
  }

  createBadgeIssueObject(): IBadgeIssueResData {
    const badgeName = `BADGE No.${faker.number.int({ max: 10000 })}`;

    return {
      createdAt: faker.date.recent().toISOString(),
      id: faker.string.uuid(),
      isActive: faker.datatype.boolean(),

      ownerId: faker.string.uuid(),
      ownerName: faker.person.firstName(),
      template: {
        badgeImageUrl: faker.image.urlPlaceholder({
          height: 640,
          width: 640,
          text: badgeName,
        }),
        createdAt: faker.date.recent().toISOString(),
        creatorId: faker.string.uuid(),
        creatorName: faker.person.firstName(),
        description: faker.commerce.productDescription(),
        id: faker.string.uuid(),
        isActive: faker.datatype.boolean(),
        issueCondition: faker.commerce.productDescription(),
        name: badgeName,
        relationLink: faker.internet.url(),
        isCertificationSbtTemplate: false,
      },
    };
  }

  get({ requestPageNumber }: { requestPageNumber: number }) {
    const startIndex = (requestPageNumber - 1) * this.limit;
    const endIndex = startIndex + this.limit;

    return {
      currentPage: requestPageNumber,
      data: this.data.slice(startIndex, endIndex),
      totalElementCount: this.totalElementCount,
      totalPage: this.totalPage,
    };
  }

  set({
    sbtStatusType,
    limit,
    search,
  }: {
    sbtStatusType?: TFetchBadgeIusseListSbtStatusType;
    limit;
    search?: string;
  }) {
    let result = this.initalData;
    if (search) {
      result = result.filter((item) => item.templateName === search);
    }
    if (sbtStatusType === 'ISSUED') {
      this.data = result.filter((item) => item.isActive);
    } else if (sbtStatusType === 'EXPIRED') {
      this.data = result.filter((item) => !item.isActive);
    } else {
      this.data = result;
    }
    this.limit = limit;
    this.totalElementCount = this.data.length;
    this.totalPage = Math.ceil(this.totalElementCount / this.limit);
  }
}

export const badgeIusseData = new BadgeIusseData({ size: 39 });

class BadgeStatistics {
  data;
  constructor() {}

  generateDataForDay() {
    const data = {};
    for (let i = 1; i <= 24; i++) {
      data[i] = faker.number.int({ min: 10, max: 100 });
    }

    this.data = data;
  }

  generateDataForMonth() {
    const today = new Date();
    const month = today.getMonth() + 1;

    const lastDay = new Date(today.getFullYear(), month, 0).getDate();

    const data = {};
    for (let i = 1; i <= lastDay; i++) {
      data[i] = faker.number.int({ min: 10, max: 100 });
    }

    this.data = data;
  }

  generateDataForYear() {
    const data = {};
    for (let i = 1; i <= 12; i++) {
      data[i] = faker.number.int({ min: 10, max: 100 });
    }

    this.data = data;
  }

  set({ duration }: { duration: TBadgeStatisticsDuration }) {
    if (duration === 'DAY') {
      this.generateDataForDay();
    } else if (duration === 'YEAR') {
      this.generateDataForYear();
    } else {
      this.generateDataForMonth();
    }
  }

  get() {
    return {
      data: this.data,
    };
  }
}

export const badgeStatistics = new BadgeStatistics();

class BadgeDetail {
  badgeInfo;
  constructor() {
    this.badgeInfo = this.createMock();
  }
  createMock(): IBadgeDetail {
    const badgeName = `BADGE No.${faker.number.int({ max: 10000 })}`;
    return {
      createdAt: faker.date.recent().toISOString(),
      isSbtExpired: false,
      ownerId: faker.string.uuid(),
      ownerName: faker.person.firstName(),
      sbtId: faker.string.uuid(),
      txId: faker.string.uuid(),
      sbtTemplate: {
        id: faker.string.uuid(),
        createdAt: faker.date.recent().toISOString(),
        name: badgeName,
        badgeImageUrl: faker.image.urlPlaceholder({
          height: 640,
          width: 640,
          text: badgeName,
        }),
        description: faker.commerce.productDescription(),
        relationLink: faker.internet.url(),
        isCertificationSbtTemplate: false,
        issueCondition: faker.commerce.productDescription(),
        expiredAt: faker.date.future().toISOString(),
        customField: ['string'],
        creatorId: faker.string.uuid(),
        creatorName: faker.person.fullName(),
      },
    };
  }
  get() {
    return this.badgeInfo;
  }
}

export const badgeDetail = new BadgeDetail();
